import ShoppingOutlet from "./ShoppingOutlet";

export default ShoppingOutlet;
